import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Grid, Text } from 'elements';
import { Button } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Colors, device } from 'GlobalStyles';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

type TPDFViewer = {
  file: string;
  userId: string;
  userPhoneNumber: string;
};

const PDFViewer = ({ file, userId, userPhoneNumber }: TPDFViewer) => {
  const ref = useRef<HTMLLinkElement>(null);
  const [total, setTotal] = useState(1);
  const [page, setPage] = useState(1);
  const [width, setWidth] = useState<number>();
  // const [instance, updateInstance] = usePDF({ document: MyDoc })

  const loadedPdf = ({ numPages }: any) => {
    setTotal(numPages);
  };

  useEffect(() => {
    if (ref.current) {
      const width = ref.current.offsetWidth;
      setWidth(width > 1250 ? 1250 : width);
    }
  }, []);

  const UserInfo = styled.div`
    position: absolute;
    /* margin:auto; */
    top: 50%;
    left: calc(50% - 7em);
    z-index: 10;
    color: #e4e4e4;
    font-weight: bolder;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 0.7;
    opacity: 0.6;
    @media screen and ${device.sm} {
      left: calc(50% - 3.5em);
    }
  `;
  const User = styled.p`
    font-size: 30px;
    @media screen and ${device.md} {
      font-size: 20px;
    }
    @media screen and ${device.sm} {
      font-size: 10px;
    }
  `;

  return (
    <Grid ref={ref} onContextMenu={(e) => e.preventDefault()}>
      <Grid justify='center' position='relative'>
        <Grid isInline border={`1px solid ${Colors.grey1}`}>
          {width && (
            <div>
              <UserInfo>
                <User>{userId}</User>
                <User>{userPhoneNumber}</User>
              </UserInfo>
              <Document file={file} className='pdf-container' onLoadSuccess={loadedPdf}>
                <Page pageNumber={page} width={width} />
              </Document>
            </div>
          )}
        </Grid>
        <Grid isInline position='absolute' style={{ left: 10, top: 'calc(50% - 10px)' }}>
          <Button
            icon={<LeftOutlined style={{ fontSize: 20 }} />}
            onClick={() => setPage(page > 1 ? page - 1 : 1)}
          />
        </Grid>
        <Grid isInline position='absolute' style={{ right: 10, top: 'calc(50% - 10px)' }}>
          <Button
            icon={
              <RightOutlined
                style={{ fontSize: 20 }}
                onClick={() => setPage(page >= total ? page : page + 1)}
              />
            }
          />
        </Grid>
        <Grid
          isInline
          position='absolute'
          justify='center'
          gap='8px'
          align='center'
          style={{ left: 0, right: 0, bottom: -30 }}
        >
          <Text bold size='1.4rem'>
            {page}
          </Text>
          <Text>/</Text>
          <Text size='1.2rem'>{total}</Text>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PDFViewer;
